// Core v2.6 §7a: feed image {href, alt, mime, width, height}, fetched only with the member session from
// GET /api/member/content/{id}/media. Pure checks; no network, no storage.
import { own } from "./memberDerive";

export const IMAGE_MIME = ["image/jpeg", "image/png", "image/webp", "image/gif", "image/avif"];
const HREF = /^(https:\/\/[^/?#]+)?\/api\/member\/content\/([A-Za-z0-9_-]{1,128})\/media$/;
const dim = (v) => (Number.isInteger(v) && v > 0 && v <= 20000 ? v : null);

// Only the configured Core (or a relative path) is ever asked; any other host would receive the member token.
export function feedImage(v, coreOrigin) {
  if (v === null || typeof v !== "object" || Array.isArray(v)) return null;
  const href = own(v, "href");
  const m = typeof href === "string" ? HREF.exec(href) : null;
  if (!m || (m[1] && m[1] !== coreOrigin)) return null;
  const mime = own(v, "mime");
  if (!IMAGE_MIME.includes(mime)) return null;
  const alt = typeof own(v, "alt") === "string" ? v.alt.trim() : "";
  const width = dim(own(v, "width"));
  const height = dim(own(v, "height"));
  return { path: `/member/content/${m[2]}/media`, alt, mime, ratio: width && height ? `${width} / ${height}` : "16 / 9" };
}

// The delivered blob must carry the announced type (parameters ignored).
export const blobMatches = (blob, mime) => Boolean(blob) && typeof blob.type === "string" && blob.type.split(";")[0].trim().toLowerCase() === mime;
